import state from './dashboard.state'
import mutations from './dashboard.mutations'
import actions from './dashboard.actions'
import getters from './dashboard.getters'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
